module.exports = __webpack_public_path__ + "static/media/animated dp2-08.8544fa0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/animated dp2-08.png
// module id = 198
// module chunks = 0